<template>
  <div>
    <l-map :style="mapStyle" ref="map" :zoom="zoom" :center="center">
      <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
      <l-marker :lat-lng="centerLatLong"></l-marker>
    </l-map>
    <vs-button
      v-if="!isPreview"
      @click="submitLocation"
      icon="check"
      class="mt-3"
      color="primary"
      >تایید موقعیت بر روی نقشه</vs-button
    >
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

export default {
  name: "LocationMap",
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: this.isPreview ? 14 : 12,
      center: this.coordinates || [36.3253812, 59.5554734],
      centerLatLong: this.coordinates || [36.3253812, 59.5554734],
      polygon: {
        latlngs: [],
        color: "green",
      },
    };
  },
  mounted() {
    const mapObject = this.$refs.map.mapObject;

    // The map can be mounted inside a hidden/animating container (popup), so
    // leaflet measures a wrong size and only paints a part of the tiles.
    this.$nextTick(() => mapObject.invalidateSize());
    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(() => mapObject.invalidateSize());
      this.resizeObserver.observe(this.$el);
    } else {
      this.resizeTimeout = setTimeout(() => mapObject.invalidateSize(), 300);
    }

    if (!this.isPreview) {
      mapObject.on("move", () => {
        const latLong = mapObject.getCenter();
        this.centerLatLong = [latLong.lat, latLong.lng];
      });
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout);
  },
  watch: {
    coordinates(newCoordinates) {
      this.center = newCoordinates;
      this.centerLatLong = newCoordinates;
    },
  },
  methods: {
    submitLocation() {
      this.$emit("selectLocation", this.centerLatLong);
    },
  },
  props: {
    polygonClicked: {
      required: false,
      type: Function,
    },
    mapStyle: {
      required: false,
      type: String,
    },
    isPreview: {
      required: false,
      type: Boolean,
    },
    coordinates: {
      required: false,
      type: Array,
    },
  },
};
</script>

<style scoped lang="scss">
.marker {
  width: 200px;
  height: 200px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
}
</style>
